import type { Dayjs } from 'dayjs';

export interface Order {
  id: number;
  orderNo: string;
  productId: number;
  sourcePlatform: string;
  sourceProductId: string;
  name: string;
  phone: string;
  idCard?: string;
  province: string;
  city: string;
  district: string;
  address: string;
  status: string;
  clientStatus?: 'applying' | 'opening' | 'shipping' | 'activated' | 'closed' | null;
  clientStatusText?: string;
  displayStatus?: string;
  platformMsg?: string;
  errorMessage?: string;
  platformStatus?: string;
  platformStatusText?: string;
  platformReason?: string;
  platformStatusDetail?: string;
  activationStatusText?: string;
  failureReason?: string;
  trackingCompany?: string;
  trackingNo?: string;
  expressName?: string;
  expressNo?: string;
  cardNumber?: string;
  platformOrderNo?: string;
  platformOrderId?: string;
  lastStatusSyncAt?: string;
  idCardFront?: string;
  idCardBack?: string;
  facePhoto?: string;
  adminRemark?: string;
  autoSubmitAttempts?: number;
  autoRetryCount?: number;
  lastAutoRetryAt?: string;
  nextAutoRetryAt?: string;
  retryCount?: number;
  lastRetryAt?: string;
  lastManualSyncAt?: string;
  exceptionStatus?: string;
  exceptionReason?: string;
  exceptionResolvedAt?: string;
  exceptionResolvedBy?: string;
  createdAt: string;
}

export type DateRangeValue = [Dayjs, Dayjs] | null;

export type OrderFilters = {
  keyword: string;
  status: string;
  sourcePlatform: string;
  clientStatus: string;
  platformStatus: string;
  platformOrderNo: string;
  name: string;
  idCard: string;
  productId: string;
  sourceProductId: string;
  dateRange: DateRangeValue;
  hasTrackingNo: string;
  hasCardNumber: string;
  exceptionStatus: string;
  exceptionOnly: string;
};

export const defaultFilters: OrderFilters = {
  keyword: '',
  status: '',
  sourcePlatform: '',
  clientStatus: '',
  platformStatus: '',
  platformOrderNo: '',
  name: '',
  idCard: '',
  productId: '',
  sourceProductId: '',
  dateRange: null,
  hasTrackingNo: '',
  hasCardNumber: '',
  exceptionStatus: '',
  exceptionOnly: '',
};
